import styled from "styled-components"
import { Icon_Link } from "../common/CommonIcons"
import { CalendarEvent } from "./AdRecruitCalendar"
import { ActionButton, NextButton } from "../common/CommonStyled"
import { useModalStore } from "src/stores/ModalStore"
import { useEffect, useState } from "react"
import { LoadRecruteDetail, RecruteDetailData, Schedule } from "./useLoadRecruitSchedule"
import { Divider } from "@mui/material"
import AdRecrutSession from "./AdRecrutSession"
import { ModalContent_RecruitCalendarDelete, ModalFooter_RecruitCalendarDelete, ModalTitle_RecruitCalendarDelete } from "./ModalRecruiteCalendarDelete"


const Title_PageWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 20px;
`
const Title_PageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    /* gap: 20px; */
`
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 54px;
    /* position: absolute; */
    right: 0;
`
interface ModalTitle_Props{
    item : CalendarEvent
    // callbackElement : CalendarEvent[]
}
export const ModalTitle_ModalRecruitCalendarDetail = ({item}:ModalTitle_Props)=>{
    const modalSetField = useModalStore((state)=>state.setField)

    useEffect(()=>{
        modalSetField('width','1120px')
        modalSetField('padding','20px')
    },[])

    const onClickDelete = async ()=>{
        modalSetField('title',<ModalTitle_RecruitCalendarDelete item={item}/>)
        modalSetField('content',<ModalContent_RecruitCalendarDelete/>)
        modalSetField('footer',<ModalFooter_RecruitCalendarDelete item={item}/>)
    }
    return(
        <Title_PageWrapper>
            <ActionButton style={{width:'94px', height:'54px'}} onClick={onClickDelete}>삭제</ActionButton>
            <Title_PageContainer>
                {item.title}
            </Title_PageContainer>
            <ButtonWrapper>
                <NextButton style={{width:'94px', height:'100%'}} onClick={()=>modalSetField('open',false)}>닫기</NextButton>
            </ButtonWrapper>
        </Title_PageWrapper>
    )
}

const Content_PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 24px;

    position: relative;
    margin-top: 24px;
    padding: 30px;
    border-radius: 20px;
    border: 1px solid #D4D4D4;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  position:relative;
`

const LabelSpan = styled.div`
  min-width: 209px;
  font-size: 18px;
  font-weight: 600;
`

const ElementWrapper = styled.div`
  flex: 1;
`
const ElementContainerA = styled.a`
  display: flex;
  align-items:center;
  gap: 10px;

  /* text-decoration: underline; */
  color: #0F172A;
  padding: 8px 10px;
  max-height: 40px;
  box-sizing: border-box;
  max-width: 809px;
`
const ElementSpan = styled.span`
  flex: 1; /* 핵심 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

interface ModalContent_Props{
    item : CalendarEvent
}
export const ModalContent_ModalRecruitCalendarDetail = ({item}:ModalContent_Props)=>{
    const [details,setDetails] = useState<RecruteDetailData | null>(null)
    useEffect(()=>{
        const fetchDetail = async ()=>{
            const response = await LoadRecruteDetail(item.announce_id)
            setDetails(response)
        }
        fetchDetail()
    },[item])
    const ensureUrlProtocol = (url: string) => {
        if (!/^https?:\/\//i.test(url)) {
            return `https://${url}`;
        }
        return url;
    };
    const createExtraSchedules = (details: any): Schedule[] => {
        const 접수: Schedule = {
            course_name: '접수',
            start_date: details.application_sdate,
            end_date: details.application_edate,
        };

        const 입영일: Schedule = {
            course_name: '입영일',
            start_date: '',
            end_date: details.enlistment_date,
        };

        const 임관일: Schedule = {
            course_name: '임관일',
            start_date: '',
            end_date: details.appointment_date,
        };

        return [접수, ...details.schedules, 입영일, 임관일];
    };
    
    if (!details) return <div>불러오는 중...</div>;
    const combinedSchedules = createExtraSchedules(details);
    return(
        <Content_PageWrapper>
            <AdRecrutSession item={item} schedules={combinedSchedules}/>
            <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
            <LabelWarpper>
                <LabelSpan>선발유형</LabelSpan>
                <ElementWrapper>{details.recruitment_type}</ElementWrapper>
            </LabelWarpper>
            <LabelWarpper>
                <LabelSpan>공고명</LabelSpan>
                <ElementWrapper>{details.title}</ElementWrapper>
            </LabelWarpper>
            <LabelWarpper>
                <LabelSpan>지원자격</LabelSpan>
                <ElementWrapper>{details.requirements}</ElementWrapper>
            </LabelWarpper>
            <LabelWarpper>
                <LabelSpan>공고 URL</LabelSpan>
                <ElementWrapper style={{backgroundColor:'#EEF6F8'}}>
                    <ElementContainerA href={ensureUrlProtocol(details.source_url)} target='blank' rel="noopener noreferrer">
                        <Icon_Link /> 
                        <ElementSpan>{details.source_url}</ElementSpan>           
                    </ElementContainerA>
                </ElementWrapper>
            </LabelWarpper>
        </Content_PageWrapper>
    )
}